import NewButton from 'CMFW/button/NewButton';
import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import ItemLayout from 'CMFW/layout/ItemLayout';
import {
  ContainerLeft,
  ContainerLeftFooter,
  ContainerLeftHeader,
  ContainerRight,
  EditorGapGreedy,
  ModuleContainer,
} from 'components/common/styles';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import React, { useMemo, useState } from 'react';
import MemoryPhrasebookModel from '../../../models/MemoryPhrasebookModel';
import MemoryPhrasebookEdit from '../components/MemoryPhrasebookEdit';
import { LoadingItem } from '../../../CMFW/layout/Loading';
import { IFields } from '../../../CMFW/grid/fields';
import SearchBarDialect from '../../../components/search/SearchBarDialect';
import MemoryPhrasebookImportModal from '../modals/MemoryPhrasebookImportModal';

type Props = { searchText?: string };

const MemoryPhrasebook: React.FC<Props> = ({ searchText }) => {
  const forceRender = useForceRender();
  const [showImportModal, setShowImportModal] = useState(false);

  const memoryPhrasebookModel = useMemo(() => new MemoryPhrasebookModel({ render: forceRender }), [forceRender]);
  React.useEffect(() => {
    if (searchText && searchText.trim() !== '') {
      memoryPhrasebookModel.search({ text: searchText });
    }
  }, [searchText]);

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={memoryPhrasebookModel}>
        <Split widthLeft={540}>
          <ContainerLeft>
            <ContainerLeftHeader>
              <SearchBarDialect onlySource />
            </ContainerLeftHeader>
            <Grid
              cellRenderers={{
                [IFields.status]: 'translationDoneStatusRenderer',
                [IFields.hasExample]: (params: any) => {
                  return params.value ? '<span class="fa fa-sticky-note" style="color:#FFC107"></span>' : '';
                },
                [IFields.isInvariable]: (params: any) => {
                  return params.value ? '<span class="fa fa-lock" style="color:#757575"></span>' : '';
                },
              }}
            />
            <ContainerLeftFooter>
              <ReloadButton />
              <Button
                style={{ marginLeft: 4 }}
                variant="outlined"
                size="small"
                onClick={async () => {
                  const response = await axios.get<{ fileName: string; fileData: string }>('/memory-phrasebook/export-csv');
                  const blob = new Blob([response.data.fileData], { type: 'text/csv' });
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement('a');
                  link.href = url;
                  link.download = response.data.fileName;
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  window.URL.revokeObjectURL(url);
                }}
              >
                CSV
              </Button>
              <Button
                style={{ marginLeft: 4 }}
                variant="outlined"
                size="small"
                onClick={() => setShowImportModal(true)}
              >
                Upload CSV
              </Button>
              <EditorGapGreedy />
              <NewButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <MemoryPhrasebookEdit />
            </ItemLayout>
            <LoadingItem />
          </ContainerRight>
        </Split>
        {showImportModal && (
          <MemoryPhrasebookImportModal
            onClose={() => setShowImportModal(false)}
            onImportComplete={() => memoryPhrasebookModel.reload()}
          />
        )}
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default MemoryPhrasebook;
